// extracted by mini-css-extract-plugin
export var layoutContainer = "_4p-0";
export var layoutContainerNoRounding = "_4p-6";
export var layoutContainerOpen = "_4p-5";
export var layoutContainerResizing = "_4p-1";
export var mainContent = "_4p-2";
export var resizeDivider = "_4p-3";
export var slidePanel = "_4p-4";